import {IWayPointCreationSingleVoyage} from "@containers/singleVoyage/types/point";

export const getRouteNameFromPointsMutateSingleVoyage = (points: IWayPointCreationSingleVoyage[]): string => {
    if (!points?.length) {
        return ''
    }
    if (points?.length < 2) {
        return points[0]?.name
    }
    return `${points[0].name} - ${points[points?.length - 1]?.name}`

}
